module.exports = __webpack_public_path__ + "static/img/James-Roberts.870d3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/James-Roberts.jpg
// module id = jyJ6
// module chunks = 0